import Vue from 'vue';
import Component from 'vue-class-component';
import { Client, PorterViewModel, GetPorterItemListViewModel,DeletePorterItemCommandArguments,UpdatePorterItemCommandArguments, PorterItemKey } from 'Api/CoreApi';
import { Prop } from 'vue-property-decorator';
import ABaseComponent from "Components/Base/ABaseComponent";
import { TypedEvent } from "Events/TypedEvent";
import { UpdateCartEvent } from "Events/Events";
import { State, Getter, Action } from 'vuex-class';
import { PorterBuilderState } from "Store/types";
import porterBuilder from 'Store/porterbuilder/porterbuilder';
import ApiProvider from 'Api/ApiProvider';

@Component({})
export default class PorterBuilderSidebarComponent extends ABaseComponent{
    
    @Prop({default:""})
    languageId:string;

    porter: PorterViewModel = null;
    porterItems: GetPorterItemListViewModel = null;

    porterId: string;
    

    client: Client;
    static updateCartEvent: TypedEvent<UpdateCartEvent> = new TypedEvent<UpdateCartEvent>();

    get porterBuilder(){
        return porterBuilder.state;
    }

    confirmDeleteModal(porterItemNumber: string) {
        $.fancybox.open({ 
            src: "#confirm-delete-modal-" + porterItemNumber
        });
    }

    deletePorterItem(porterItemKey: string) {
        const args = new DeletePorterItemCommandArguments({
            key: new PorterItemKey({
                id: porterItemKey
            })
        });
        porterBuilder.dispatchDeletePorterItem(args).then(() => {});
    }

    updatePorterItem(porterItemKey: string, comment: string) {
        const args = new UpdatePorterItemCommandArguments({
            porterItemKey: new PorterItemKey({
                id: porterItemKey
            }),
            comment: comment
        });
        porterBuilder.dispatchUpdatePorterItem(args).then(() => {

        });
    }

    async created() {
        await porterBuilder.dispatchInitializePorter();
        if(this.porterBuilder.porter){
            await porterBuilder.dispatchLoadPorterItems(this.languageId).then(() => this.setLoaded()).catch(e => this.setError(e));
        }
        
    }
}
Vue.component("porter-builder-sidebar",PorterBuilderSidebarComponent);